import React from "react"

import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"
import type { Services } from "@/lib/services"
import {
  defaultServiceLabel,
  defaultServiceOption,
} from "@/lib/services/constants"

export const ServicesContext = React.createContext<Services.ContextData>({
  selectService: contextPlaceholderFunction,
  selected: defaultServiceOption,
  selectedLabel: defaultServiceLabel,
})
